import { useState } from 'react'

import {
  useProductStore,
  useProductStoreActions,
} from '../stores/product.store'
import type {
  TEventClick,
  TProductImageOrderHook,
} from '../types/product-image-order-hook.type'

export const useProductImageOrderHook = (): TProductImageOrderHook => {
  const [itemsOffset, setItemsOffset] = useState(0)

  const { setProductIdSelected, setProductImage, setIsOpenModalProductImage } =
    useProductStoreActions
  const { productImage, isOpenModalProductImage } = useProductStore()

  const itemsPerPage = 1

  const endOffset = itemsOffset + itemsPerPage

  const currentItems = productImage?.slice(itemsOffset, endOffset)
  const pageCount = Math.ceil(productImage?.length ?? 0 / itemsPerPage)

  const handlePageClick = (event: TEventClick) => {
    const newOffset = (event.selected * itemsPerPage) % productImage.length
    setItemsOffset(newOffset)
  }

  const handleCloseModal = () => {
    setIsOpenModalProductImage(false)
    setProductIdSelected(undefined)
    setItemsOffset(0)
    setProductImage(undefined)
  }

  return {
    state: {
      pageCount,
      currentItems,
      isOpenModal: isOpenModalProductImage,
    },
    action: {
      onPageClick: handlePageClick,
      onCloseModal: handleCloseModal,
    },
  }
}
